import { EmployeeProfile } from '@/types/nib/employeeProfile';
import { PAY_INDICATOR_LABELS, CATEGORY_LABELS } from '@/types/nib/manualEntry';
import { SearchHighlight } from './SearchHighlight';

interface ProfileCardProps {
  profile: EmployeeProfile;
  search?: string;
  isDeleting?: boolean;
  onDelete?: () => void;
}

export function ProfileCard({
  profile,
  search = '',
  isDeleting,
  onDelete,
}: ProfileCardProps) {
  return (
    <div className="relative bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm transition-all">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-900">
              <SearchHighlight text={profile.first_name} search={search} />{' '}
              <SearchHighlight text={profile.last_name} search={search} />
            </span>
            {profile.nickname && (
              <span className="text-sm text-gray-500">
                (<SearchHighlight text={profile.nickname} search={search} />)
              </span>
            )}
            {!profile.is_active && (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                Inactive
              </span>
            )}
          </div>
          <div className="mt-1 flex items-center gap-4 text-sm text-gray-500">
            <span>
              NI: <SearchHighlight text={profile.ni_number} search={search} />
            </span>
            <span>{PAY_INDICATOR_LABELS[profile.default_pay_indicator]}</span>
            <span>{CATEGORY_LABELS[profile.default_category]}</span>
            <span>{profile.default_weeks}wk</span>
          </div>
        </div>

        {onDelete && (
          <button
            onClick={onDelete}
            disabled={isDeleting}
            className="ml-4 p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
            aria-label={`Delete ${profile.first_name} ${profile.last_name}`}
          >
            {isDeleting ? (
              <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            )}
          </button>
        )}
      </div>
    </div>
  );
}
